import Vue from "vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

Vue.use(ClientTable);
Vue.use(ServerTable);
